/*
 * @version: V1.0.0
 * @Date: 2023-10-27 16:50:49
 * @LastEditors: lzq
 * @LastEditTime: 2023-10-30 16:39:44
 * @company: 睿展数据
 * @FilePath: \udi-wms-client\src\utils\index.js
 * @Descripttion: 
 */
import Layout from '@/components/Container.vue'

// 遍历后台传来的路由字符串，转换为组件对象
export function filterAsyncRouter(asyncRouterMap) {
  asyncRouterMap.forEach(route => {
    if (route.component) {
      // Layout ParentView 组件特殊处理
      if (route.component === 'Layout' || route.name === 'Index') {
        route.component = Layout
      } else {
        route.component = loadView(route.component)
      }
    }
    if (route.children != null && route.children && route.children.length) {
      route.children = filterAsyncRouter(route.children)
    } else {
      delete route['children']
      delete route['redirect']
    }
  })
  console.log(asyncRouterMap);
  return asyncRouterMap
}

export function filterChildren(childrenMap) {
  var children = []
  childrenMap.forEach((route) => {
    children = children.concat(route)
  })
  return children
}

export const loadView = (view) => {
  // if (process.env.NODE_ENV === 'development') {
  //   return (resolve) => require([`@/pages${view}`], resolve)
  // }
  // // 使用 import 实现生产环境的路由懒加载
  // return () => import(`@/pages${view}`)
  return (resolve) => require([`@/views${view}`], resolve)
}


